import React from 'react';
import { useAuth } from '../hooks/useAuth';
import Login from './Login';
import LoadingSpinner from './LoadingSpinner';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading, login, error } = useAuth();

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (!isAuthenticated) {
    return <Login onLogin={login} error={error} />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
